export { FrameContexts as MetaOsHubFrameContexts } from '@microsoft/teams-js';
import { pages } from '@microsoft/teams-js';

import { isInMetaOsHub } from './isInMetaOsHub';

type RegisterFocusEnterHandlerProps = Parameters<(typeof pages)['registerFocusEnterHandler']>;

type RegisterFocusEnterHandler = (...params: RegisterFocusEnterHandlerProps) => Promise<void>;
export const registerFocusEnterHandler: RegisterFocusEnterHandler = async (...params) => {
  const inMetaOsHubContext = await isInMetaOsHub();

  if (!inMetaOsHubContext) {
    return;
  }

  pages.registerFocusEnterHandler(...params);
};

type ReturnFocusHandlerProps = Parameters<(typeof pages)['returnFocus']>;

export const ReturnFocusType: typeof pages.ReturnFocusType = pages.ReturnFocusType;

type ReturnFocusHandler = (...params: ReturnFocusHandlerProps) => Promise<void>;
export const returnFocusHandler: ReturnFocusHandler = async (...params) => {
  const inMetaOsHubContext = await isInMetaOsHub();

  if (!inMetaOsHubContext) {
    return;
  }

  pages.returnFocus(...params);
};
